'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SplitConsumer = exports.SplitProvider = exports.initGlobalSplitFactory = exports.globalSplitFactory = exports.SplitContext = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _splitio = require('@splitsoftware/splitio');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var SplitContext = exports.SplitContext = _react2.default.createContext({}); // NOTE: We use 2 split clients for most of the frontend apps,
// 1. handles splits before user data is fetched e.g. with sentry logs
// 2. handles splits inside components using <SplitProvider />


var globalSplitFactory = exports.globalSplitFactory = void 0;

var initGlobalSplitFactory = exports.initGlobalSplitFactory = function initGlobalSplitFactory(authKey) {
  var userId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'user_id';

  if (authKey) {
    exports.globalSplitFactory = globalSplitFactory = (0, _splitio.SplitFactory)({
      startup: {
        readyTimeout: 15,
        requestTimeoutBeforeReady: 5,
        retriesOnFailureBeforeReady: 2
      },
      core: {
        authorizationKey: authKey,
        key: userId
      }
    });
  }

  return globalSplitFactory;
}; // NOTE: the authKey is what determines what env in Split.io to use


var getSplitio = function getSplitio() {
  var authKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'qug52q9g8fmei3ohfvs4g1gn314t0osf6lv1';
  var userId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'user_id';

  if (userId && authKey) {
    if (!globalSplitFactory) {
      initGlobalSplitFactory(authKey, userId);
      return globalSplitFactory.client();
    } // create second split client


    return globalSplitFactory.client(userId);
  }

  return null;
};

var SplitProvider = exports.SplitProvider = function (_React$Component) {
  _inherits(SplitProvider, _React$Component);

  function SplitProvider(props) {
    _classCallCheck(this, SplitProvider);

    var _this = _possibleConstructorReturn(this, (SplitProvider.__proto__ || Object.getPrototypeOf(SplitProvider)).call(this, props));

    _this.startSplitIo = function (client, attributes, setAsBoolean) {
      var splits = _this.props.splits;

      if (client) {
        client.on(client.Event.SDK_READY, function () {
          var treatments = client.getTreatments(splits, attributes);
          Object.keys(treatments).forEach(function (splitName) {
            var value = treatments[splitName]; // convert on/off into a boolean for ease of use
            // if setAsBoolean boolean is on and it's value != on set false
            // otherwise use the treament name

            if (value === 'on') {
              _this.setState(_defineProperty({}, splitName, true));
            } else if (value === 'off' || setAsBoolean) {
              _this.setState(_defineProperty({}, splitName, false));
            } else {
              _this.setState(_defineProperty({}, splitName, value));
            }
          });

          _this.setState({
            isPending: false
          });
        });
      }
    };

    _this.killSplitIo = function () {
      if (_this.splitClient) {
        _this.splitClient.destroy().then(function () {
          _this.splitClient = null;
        });
      }
    };

    _this.initiateSplitIo = function () {
      var authKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'qug52q9g8fmei3ohfvs4g1gn314t0osf6lv1';
      var userId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'user_id';
      var attributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var setAsBoolean = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var shouldManuallyStart = _this.props.shouldManuallyStart;

      if (shouldManuallyStart) {
        _this.splitClient = getSplitio(authKey, userId);

        if (_this.splitClient) {
          _this.startSplitIo(_this.splitClient, attributes, setAsBoolean);
        }
      }
    };

    _this.state = {
      isPending: true
    };
    return _this;
  }

  _createClass(SplitProvider, [{
    key: 'componentDidMount',
    // look into using manager instead of client
    value: function componentDidMount() {
      var _props = this.props,
          authKey = _props.authKey,
          shouldManuallyStart = _props.shouldManuallyStart,
          userId = _props.userId;

      if (!shouldManuallyStart) {
        this.splitClient = getSplitio(authKey, userId);
        this.startSplitIo(this.splitClient);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props2 = this.props,
          authKey = _props2.authKey,
          shouldManuallyStart = _props2.shouldManuallyStart,
          userId = _props2.userId;

      if (prevProps.authKey !== authKey || prevProps.userId !== userId) {
        if (!shouldManuallyStart) {
          this.killSplitIo();
          this.splitClient = getSplitio(authKey, userId);
          this.startSplitIo(this.splitClient);
        }
      }
    } // shutdown splitio whenever the app unmounts

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.killSplitIo();
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(SplitContext.Provider, {
        value: _extends({}, this.state, {
          initiateSplitIo: this.initiateSplitIo
        })
      }, this.props.children);
    }
  }]);

  return SplitProvider;
}(_react2.default.Component);

SplitProvider.defaultProps = {
  // defaults to setup split.io on launch can also manually trigger it
  shouldManuallyStart: false,
  splits: []
};
var SplitConsumer = exports.SplitConsumer = SplitContext.Consumer;